<template>
<div class="bad" v-if="bad.length">
  <h3>Плохо</h3>
  <span v-for='(item,index) in bad' :key='index'>{{item}}</span>
</div>
</template>
<script>
export default {
  name: 'GoodView',
  components:{},
  data:()=>({}),
  props:{
    goodOrBad: {type: Array, default: ()=>([])}
  },
  computed:{
    bad(){
      return (this.goodOrBad.filter(item=>item.value < 0).map(item=>item.name))
    }
  },
}
</script>
<style lang="sass" scoped>
.bad
  position: relative
  display: grid
  padding: 0 15px
  &::before
    content: ""
    display: 'block'
    width: 8px
    height: 100%
    background-color: red
    position: absolute
    left: 0
  h3
    color: rgba(0,0,0,.6)
  span
    font-weight: 700
    font-size: 1.1rem
</style>
